// Default carousel configuration options
export const DEFAULT_CAROUSEL_OPTIONS = {
  align: 'center',
  containScroll: 'trimSnaps',
  dragFree: false,
  loop: false,
  skipSnaps: false,
  startIndex: 0
};

// Context-specific carousel configurations
export const CONTEXT_CAROUSEL_OPTIONS = {
  category: {
    ...DEFAULT_CAROUSEL_OPTIONS,
    align: 'start',
    slidesToScroll: 'auto'
  },
  borrowing: {
    ...DEFAULT_CAROUSEL_OPTIONS,
    align: 'center',
    loop: true
  },
  resource: {
    ...DEFAULT_CAROUSEL_OPTIONS,
    align: 'center'
  }
};

// Thumbnail size specific configurations
export const THUMBNAIL_SIZE_OPTIONS = {
  80: {
    slideSize: '120px',
    slideSpacing: '0.5rem',
    height: '80px'
  },
  120: {
    slideSize: '160px',
    slideSpacing: '0.75rem',
    height: '120px'
  },
  300: {
    slideSize: '320px',
    slideSpacing: '1rem',
    height: '300px'
  },
  null: { // Full size
    slideSize: '70%',
    slideSpacing: '1rem',
    height: '19rem'
  }
};

export const getCarouselOptions = (context, customOptions = {}) => {
  const contextOptions = CONTEXT_CAROUSEL_OPTIONS[context] || DEFAULT_CAROUSEL_OPTIONS;

  return {
    ...contextOptions,
    ...customOptions
  };
};

export const getThumbnailSizeConfig = (thumbnailSize) => {
  return THUMBNAIL_SIZE_OPTIONS[thumbnailSize] || THUMBNAIL_SIZE_OPTIONS[null];
};